import ApiService, { HTTPMethod } from './api.core'

class ChargesApi {
  async requestRefund(insuranceId, motorcycles) {
    let dataAsString = JSON.stringify(motorcycles)
    return await ApiService.fetch(`charges/${insuranceId}/get_refund_amount&motorcycles=${dataAsString}`, HTTPMethod.GET)
  }

  async approveRefund(insuranceId, motorcycles, refundReason, refundComment) {
    return await ApiService.fetch(`charges/${insuranceId}/refund_insurance`, HTTPMethod.POST, {
      motorcycles: motorcycles,
      refund_reason: refundReason,
      refund_comment: refundComment,
    })
  }

  async rechargeUser(userId) {
    return await ApiService.fetch(`charges/${userId}/recharge_user`, HTTPMethod.POST)
  }

  async uploadOdometer(insuranceId, data) {
    let formData = new FormData()
    formData.append('vehicleId', data.motorcycleId)
    formData.append('image', data.image)

    return await ApiService.fetch(`insurances/${insuranceId}/odometer_upload_admin`, HTTPMethod.POST, formData, false)
  }

  async checkChargeStatus(insuranceId) {
    return await ApiService.fetch(`creditcards/me/get-charge-status/${insuranceId}`, HTTPMethod.GET)
  }
}
export default new ChargesApi()
